import {graphql, useStaticQuery} from 'gatsby'
import React from 'react'

import {useLocalizedContent} from '@/hooks/use-localized-content'
import {VideoLibrary} from '@/sections/video-library'

import type {ResourceDetailPageVideoLibraryQuery, VideoLibrarySliceFragment} from '@/graphql-types'

interface Props {
    title: VideoLibrarySliceFragment['primary']['title']
}

export const VideoLibrarySlice = ({title}: Props) => {
    const {allPrismicResourceDetailPage} =
        useStaticQuery<ResourceDetailPageVideoLibraryQuery>(videosQuery)
    const content = useLocalizedContent(allPrismicResourceDetailPage.nodes)

    return <VideoLibrary title={title} items={content.map(({data, uid}) => ({...data, uid}))} />
}

const videosQuery = graphql`
    query ResourceDetailPageVideoLibrary {
        allPrismicResourceDetailPage {
            nodes {
                uid
                lang
                data {
                    title
                    description
                    category
                    duration
                    thumbnail {
                        alt
                        copyright
                        url
                        dimensions {
                            height
                            width
                        }
                        gatsbyImageData(
                            breakpoints: [720, 940, 1080, 1440]
                            sizes: "(max-width: 767px) 100vw, (max-width: 1440px) 33vw, 400px"
                        )
                    }
                }
            }
        }
    }
`

export const videoLibrarySliceFragment = graphql`
    fragment VideoLibrarySlice on PrismicSlicePageDataBodyVideoLibrary {
        __typename
        primary {
            title
        }
    }
`
